import styled from "styled-components";
import { Box } from "../Box";

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const Flex: any = styled(Box)<{ display: any }>`
  display: ${({ display }) => (display ? display : "flex")};
`;
